<template lang="pug">
  .quote-cart
    .draft-track
      h3 Quote Request #: 
      span.right(v-if="!$root.currentUser.guest")
        svg(xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16")
          path(d="M15.5,35.5l-3-3A1.714,1.714,0,0,0,11.29,32H1.714A1.714,1.714,0,0,0,0,33.714V46.286A1.714,1.714,0,0,0,1.714,48H14.286A1.714,1.714,0,0,0,16,46.286V36.71a1.714,1.714,0,0,0-.5-1.212ZM8,45.714a2.286,2.286,0,1,1,2.286-2.286A2.286,2.286,0,0,1,8,45.714Zm3.429-10.876v3.59a.429.429,0,0,1-.429.429H2.714a.429.429,0,0,1-.429-.429V34.714a.429.429,0,0,1,.429-.429h8.161a.428.428,0,0,1,.3.126l.124.124a.428.428,0,0,1,.126.3Z" transform="translate(0 -32)" fill="#5c5c5c")
        | Autosaved
      p.quote {{quote.id}}
        span.tag Draft
      ul.progress-bar
        li.clickable(:class="[step == 1 ? 'active' : '', step > 1 ? 'complete' : '']" @click="goToStep(1)") Products
        li.clickable(:class="[quote.items.length == 0 ? 'disabled' : '', step == 2 ? 'active' : '', step > 2 ? 'complete' : '']" @click="quote.items.length > 0 ? goToStep(2) : null")  Shipping
        li.clickable(:class="[quote.items.length == 0 || $root.currentUser.guest ? 'disabled' : '', step == 3 ? 'active' : '', step > 3 ? 'complete' : '']" @click="validateInfo()")  Request Quote

    //STEP 1  
    .draft-container
      .product-view(v-if="subView == 'products'")
        .empty-order(v-if='quote.items.length == 0')
          p 
            strong Your draft is empty
          p Add a product to your quote to get started!
        .product(v-else v-for='item in quote.items')
          .image
            a.thumb-wrapper(:href="item.product.fullLink")
              img(:src="item.product.image")
          .description
            a(:href="item.product.link" target="_blank")
              h4.product-title {{ item.product.title }}
            p.product-variations {{ item.notes }}
          .quantity
            .subtract.clickable(@click="subtractOne(item)")
              span -
            input(v-model="item.quantity", type="number", pattern="-?(\d+|\d+\.\d+|\.\d+)([eE][-+]?\d+)?",  @keyup="onItemChange(item)")
            .add.clickable(@click="addOne(item)")
              span +
            .remove.clickable(@click="removeItem(item.product.id)")
              span Remove
        hr
        button.action(:class="quote.items.length == 0 ? 'disabled' : ''" :disabled="quote.items.length == 0" @click="goToStep(2)") Build Quote
        p.delete-quote
          a(@click="deleteConfirm") Delete Quote

      //STEP 2 GUEST
      .login-existing-account(v-else-if="subView == 'contact' && $root.currentUser.guest")
        h2 Where would you need this shipped?

        label(for="existing-login")
          input(type="radio" id="existing-login" name="account" value="existing-login" v-model="addressState")
          span Use my Account setting, sign me in:
        login(v-if="addressState == 'existing-login'")
        
        label(for="create-account")
          input(type="radio" id="create-account" name="account" value="create-account" v-model="addressState")
          span Create New Account
            em (For quicker quote processing)
        createAccount(v-if="addressState == 'create-account'")

      //STEP 2 ACCOUNT
      .address-view(v-else-if="subView == 'contact'")
        h2 Where would you need this shipped?
        
        label(for="account-info")
          input(type="radio" id="account-info" name="account" value="existing-account" v-model="addressState")
          span(:class="addressState == 'existing-account' ? 'active' : ''") Use My Account Info:
        .existing-account(v-if="addressState == 'existing-account'")        
          p {{accountInfo.business}}
          p {{accountInfo.street}}
          p {{accountInfo.city}}, {{ accountInfo.state}} {{ accountInfo.postalCode }}
          br 
          p Attn: {{accountInfo.name}}
          p Phone: {{accountInfo.phoneNumber}}
          br
          p(v-if="accountInfo.taxExempt") Yes, we are tax exempt
              
        label(for="new-account")
          input(type="radio" id="new-account" name="account" value="new-account" v-model="addressState")
          span(:class="addressState == 'new-account' ? 'active' : ''") Enter New Delivery Info:
        .new-account(v-if="addressState == 'new-account'")        
          account(ref="accountDetails")
        .loading-options
          p Does this location have an accessible loading dock?         
          label(for="no-loading-dock")
            input(type="radio" id="no-loading-dock" name="loading-dock" :value="false" v-model="quote.hasDock")
            | No loading dock is available. A lift gate is needed.
          label(for="loading-dock")
            input(type="radio" id="loading-dock" name="loading-dock" :value="true" v-model="quote.hasDock")
            | Yes, there is a loading dock at this location

          
      .delivery-time(v-if="!$root.currentUser.guest && subView == 'contact'")
        p Requested Delivery Time Frame:
        
        datepicker(:inline="true" calendar-class="date-picker" v-model="quote.deliveryTimeframe")


        button.action(@click="addressState == 'new-account' ? validateInfo() : goToStep(3)" ) Review Quote

      //STEP 3
      .check-out-view(v-else-if="subView == 'checkout'")
        .existing-account
          h4.bold Delivery Address:
          p {{accountInfo.business}}
          p {{accountInfo.street}}
          p {{accountInfo.city}}, {{ accountInfo.state}} {{ accountInfo.postalCode }}
          br 
          p Attn: {{accountInfo.name}}
          p Phone: {{accountInfo.phoneNumber}}
          br
          p(v-if="!quote.hasDock") No loading dock, please include lift gate
          P(v-else) Yes, there is a loading dock at this location
        hr
        .date
          p.bold Deliver By:
          p {{formatDate(quote.deliveryTimeframe)}}
        hr
        .product-view
          p.header.bold Products:
            span.right Qty:
          .product(v-for='item in quote.items')
            .image
              a.thumb-wrapper(:href="item.product.fullLink")
                img(:src="item.product.image")
            .description
              a(:href="item.product.link" target="_blank")
                h4.product-title {{ item.product.title }}
              p.product-variations {{ item.notes }}
            .quantity
              p {{item.quantity}}
        hr
        p.total.bold Total Qty:
          span.right {{totalQuantity}}
        h4.bold Notes for Sales Rep:
        textarea.notes(v-model="quote.notes" placeholder="Please let your sales rep know if you have any additional notes or questions about your quote request")
        button.action( @click="goToStep(4)") Submit Quote
        p.link
          a( @click="goHome()") Submit later
        
    financing(v-if="this.$root.currentSite == 'MityLite' && subView == 'checkout'")

</template>

<script>
import { Quotes } from "../scripts/quotes.js";
import Accounts from "../scripts/accounts.js";
import Datepicker from "vuejs-datepicker";
import Axios from "axios";
import Activity from "../scripts/activity.js";
import { Country } from "../scripts/country-state.js";

export default {
  name: "Cart",
  props: ["quote"],
  components: {
    Datepicker
  },
  data() {
    return {
      step: 1,
      addressState: this.$root.currentUser.guest
        ? "existing-login"
        : "existing-account",
      subView: "products",
      accountInfo: {},
      notes: ""
    };
  },
  computed: {
    totalQuantity: function() {
      var total = 0;
      for (var i = 0; i < this.quote.items.length; i++) {
        total = total + parseInt(this.quote.items[i].quantity);
      }
      return total;
    }
  },
  methods: {
    validateInfo() {
      if (this.addressState == "new-account") {
        if (
          this.quote.items.length > 0 &&
          this.$refs.accountDetails.verifyInfo
        ) {
          this.goToStep(3);
        } else {
          this.$refs.accountDetails.submitCheck = true;
        }
      } else if (this.addressState == "existing-account") {
        if (this.quote.items.length > 0) {
          this.goToStep(3);
        }
      }
    },
    onItemChange(item) {
      if (item && parseInt(item.quantity) === 0) {
        this.removeItem(item.product.id);
      }
      this.quote.lastUpdated = new Date().valueOf();
      this.quote.lastUpdatedBy = this.$root.currentUser
        ? this.$root.currentUser.uid
        : "anon";
      this.updateQuote();
    },
    addOne(item) {
      item.quantity++;
      this.onItemChange(item);
    },
    subtractOne(item) {
      item.quantity--;
      this.onItemChange(item);
    },
    removeItem(productId) {
      let idx = this.quote.items.findIndex(
        item => item.product.id == productId
      );
      var item = this.quote.items[idx];
      if (idx >= 0) {
        this.quote.items.splice(idx, 1);
      }
      this.onItemChange(item);

      if (this.$root.currentUser.uid.length > 0) {
        Activity.userActivity(this.$root.currentUser, "request:removeProduct", {
          product: {
            directoryURL: "/",
            fullLink: item.product.link,
            id: item.product.id,
            image: item.product.image,
            quantity: item.quantity,
            title: item.product.title
          }
        });
      }
    },
    goToStep(nextStep) {
      this.saving = true;
      this.step = nextStep;
      this.quote.step = this.step;

      if (
        this.$root.activeDraft &&
        !this.$root.currentUser.guest &&
        this.$root.activeDraft.id == this.quote.id
      ) {
        Quotes.saveQuote(this.quote);
      }

      if (nextStep == 1) {
        this.subView = "products";
        if (this.$root.env != "development") {
          if (this.quote.items.length > 0) {
            this.trackGAProcess(nextStep);
          }
        }
      } else if (nextStep == 2) {
        this.subView = "contact";
        if (this.$root.env != "development") {
          this.trackGAProcess(nextStep);
        }
      } else if (nextStep == 3) {
        if (this.addressState == "new-account") {
          this.$refs.accountDetails.saveAccount();
        }
        this.subView = "checkout";
        if (this.$root.env != "development") {
          this.trackGAProcess(nextStep);
        }
      } else if (nextStep == 4) {
        this.submitQuote();
      }
    },
    goHome() {
      this.updateQuote();
      this.$root.confirmation.msg = "Saved as Draft!";
      this.$root.confirmation.returnState = "quotes";
      this.$root.confirmation.returnMsg = "Manage drafts";
      this.$root.confirmation.open = true;
    },
    updateQuote() {
      if (!this.$root.currentUser.guest) {
        Quotes.saveQuote(this.quote);
      }
      this.$root.activeDraft = this.quote;
      var draftStr = JSON.stringify(this.quote);
      sessionStorage.setItem("draft_quotes", draftStr);
    },
    submitQuote() {
      if (!this.quote.forUser) {
        this.quote.forUser = this.accountInfo.uid;
      }
      if (this.$root.env != "development") {
        this.addHubspot();
        this.trackGASubmit();
      }
      this.step = 4;
      this.quote.state = "requested";
      this.quote.startedAt = Date.now();
      this.quote.requestedTime = Date.now();
      this.quote.liftGateCharge = this.quote.hasDock ? 0 : 50;
      Quotes.saveQuote(this.quote);
      console.log(this.quote.id + " requested");

      Accounts.updateLastLogin(this.$root.currentUser);
      Activity.userActivity(this.$root.currentUser, "request:submit", {
        quote: this.quote,
        customer: this.accountInfo
      });

      this.$root.confirmation.msg = "Quote Request Submitted!";
      this.$root.confirmation.returnState = "quotes";
      this.$root.confirmation.returnMsg = "View Your Requests";
      this.$root.confirmation.open = true;
      this.$root.activeDraft = "";
      sessionStorage.clear();
    },
    getAccount() {
      Accounts.getAccount(this.$root.currentUser.uid).then(results => {
        if (results) {
          this.accountInfo = results;
          this.accountInfo.uid = this.$root.currentUser.uid;

          //Check existing account for COUNTRY abbreviation
          if (!this.accountInfo.countryAbbr) {
            Country.getAllCountries().then(allCountries => {
              for (var i in allCountries) {
                if (allCountries[i].name == this.accountInfo.country) {
                  this.accountInfo.countryAbbr = allCountries[i].iso2;
                }
              }

              Accounts.saveAccount(this.accountInfo);
            });
          }
        } else {
          this.step = 1;
          this.goToStep(1);
        }
      });
    },
    deleteConfirm() {
      this.$root.confirmation.msg =
        "Are you sure you want to delete this quote?";
      this.$root.confirmation.returnState = "delete";
      this.$root.confirmation.returnMsg = "Yes, Delete Quote";
      this.$root.confirmation.open = true;
      this.$root.confirmation.confirm = true;
    },
    addHubspot() {
      if (this.accountInfo.email) {
        var fullName = this.accountInfo.name.split(" "),
          firstName = fullName[0],
          lastName = fullName[fullName.length - 1];

        if (lastName == firstName) {
          lastName = "";
        }

        const submitDate = new Date().setUTCHours(0, 0, 0, 0);
        var site = this.$root.currentSite;

        var data = {
          properties: {
            email: this.accountInfo.email,
            firstname: firstName,
            lastname: lastName,
            company: this.accountInfo.business,
            industry_2021:
              this.accountInfo.primaryIndustry || this.accountInfo.industry,
            sub_industry: this.accountInfo.primaryIndustry
              ? this.accountInfo.industry
              : "",
            phone: this.accountInfo.phoneNumber,
            address: this.accountInfo.street,
            city: this.accountInfo.city,
            state_province: this.accountInfo.state,
            zip: this.accountInfo.postalCode,
            country2021: this.accountInfo.country,
            hs_analytics_source: "DIRECT_TRAFFIC",
            lead_source_detail: "MityQuotes",
            mityquotes_recent_activity: "" + submitDate + "",
            mityquotes_site: site,
            mityquotes_number: this.quote.id
          }
        };
        var options = {
          url:
            "https://us-central1-mity-web-components.cloudfunctions.net/hubspot-addContact",
          headers: {
            token: "dxkqnp2hZDb5S68",
            "content-type": "application/json",
            email: this.accountInfo.email
          },
          data: data,
          method: "post"
        };
        Axios(options)
          .then(response => {})
          .catch(function(error) {
            console.warn(error);
          });
      }
    },
    sendCRMLead(account, quote) {
      let site = this.$root.currentSite;

      let options = {
        url:
          "https://us-central1-mity-web-components.cloudfunctions.net/crm-lead",
        headers: {
          token: "dxkqnp2hZDb5S68"
        },
        data: {
          account,
          quote,
          site
        },
        method: "post"
      };
      Axios(options)
        .then(response => {
          console.log(response);
        })
        .catch(function(error) {
          console.warn(error);
        });
    },
    trackGAProcess(nextStep) {
      try {
        dataLayer.push({
          event: "checkout",
          ecommerce: {
            checkout: {
              actionField: { step: this.step }
            }
          }
        });
      } catch (e) {
        console.warn("Google Analytics is not available", e);
      }
    },
    trackGASubmit() {
      var id = this.quote.id;
      let transactionProducts = [];

      for (var i in this.quote.items) {
        transactionProducts.push({
          id: this.quote.items[i].product.id,
          name: this.quote.items[i].product.title,
          quantity: this.quote.items[i].quantity,
          brand: this.accountInfo.industry
        });
      }

      dataLayer.push({
        event: "purchase",
        ecommerce: {
          purchase: {
            actionField: { id: id },
            products: transactionProducts
          }
        }
      });
    }
  },
  mounted: function() {
    this.$root.currentPage = "Quotes";

    if (!this.$root.currentUser.guest) {
      this.getAccount();
      Activity.userActivity(this.$root.currentUser, "request:view", {
        quote: this.quote
      });
    } else {
      this.step = 1;
      this.goToStep(1);
    }

    if (this.quote.step) {
      this.goToStep(this.quote.step);
    }

    this.$root.$on("restart", () => {
      this.$root.activeDraft.step = 1;
      this.goToStep(1);
    });

    // Default 30 days on delivery time frame
    let msDays = new Date().getTime() + 86400000 * 30;
    let deliveryDefaultDate = new Date(msDays);
    this.quote.deliveryTimeframe = this.formatDate(deliveryDefaultDate);
  }
};
</script>

<style lang="scss">
@import "../assets/styles/reset.scss";
@import "../assets/styles/variables.scss";
#app .quote-cart {
  .bold {
    font-weight: 500;
  }
  .clickable:hover {
    cursor: pointer;
  }
  hr {
    margin: 1em 0;
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-bottom: solid 2px $border_gray;
    width: 100%;
  }
  .draft-track {
    background: $light_gray;
    font-size: 0.9em;
    padding: 1em 24px;
    h3 {
      display: inline-block;
    }
    span.right {
      color: $text_color;
      float: right;
      line-height: normal;
      svg {
        height: 15px;
        margin-right: 5px;
        fill: $text_color;
        vertical-align: bottom;
        path {
          stroke: $text_color;
        }
      }
    }
    p.quote {
      color: $text_color;
      font-size: 1.25em;
      font-weight: 500;
      padding: 0.25em 0;
      span.tag {
        background-color: $alert_orange;
        color: #fff;
        font-weight: 300;
        font-size: 0.6em;
        padding: 2px 6px 2px 4px;
        font-style: italic;
        vertical-align: middle;
        margin-left: 5px;
      }
    }
    .progress-bar {
      counter-reset: step;
      display: flex;
      margin: 1em 0px;
      li {
        list-style-type: none;
        width: 33.33%;
        float: left;
        font-size: 12px;
        position: relative;
        text-align: center;
        color: $link_color;
      }
      li:hover:not(.disabled) {
        color: $link_hover;
      }
      li:before {
        width: 30px;
        height: 30px;
        content: counter(step);
        counter-increment: step;
        line-height: 30px;
        border: 2px solid $border_gray;
        display: block;
        text-align: center;
        margin: 0 auto 10px auto;
        border-radius: 50%;
        background-color: white;
        position: relative;
        z-index: 1;
      }
      li:after {
        width: 100%;
        height: 7px;
        content: "";
        position: absolute;
        background-color: $border_gray;
        top: 11px;
        left: -50%;
        z-index: 0;
      }
      li:first-child:after {
        content: none;
      }
      li.active {
        color: $link_hover;
      }
      li.active:before {
        color: #fff;
        background-color: $primary_color;
        border-color: $primary_color;
      }
      li.active:after,
      li.complete:after {
        background-color: $primary_color;
      }
      li.complete:before {
        color: #fff;
        content: "\2713";
        background-color: $primary_color;
        border-color: $primary_color;
      }
      li.disabled {
        cursor: inherit;
        color: $text_color;
      }
    }
  }
  .draft-container {
    margin: 1em 24px;
  }
  .product-view {
    font-size: 0.9em;
    .product {
      display: flex;
      flex-wrap: wrap;
      margin: 1.5em 0;
      .image {
        padding-right: 0.8em;
        width: 20%;
        img {
          width: 100%;
        }
      }
      .description {
        width: 55%;
        padding: 0 5px;
        .product-title {
          font-weight: 500;
          color: $link_color;
          margin-bottom: 5px;
        }
        .product-title:hover {
          color: $link_hover;
        }
        .product-variations {
          font-size: 0.875em;
        }
      }
      .quantity {
        width: 25%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        .subtract,
        .add {
          border: none;
          background: transparent;
          width: 10%;
          padding: 0;
          span {
            width: 100%;
            font-size: 1.3em;
          }
        }
        input {
          width: 60%;
          max-width: 60px;
          text-align: right;
          padding: 5px;
          margin: 0;
          border: 1px solid #ccc;
          height: 25px;
          border-radius: 8px;
        }
        /* Chrome, Safari, Edge, Opera */
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        /* Firefox */
        input[type="number"] {
          -moz-appearance: textfield;
        }
        .remove {
          color: $link_color;
          width: 100%;
          text-align: right;
          background: transparent;
          border: none;
          text-decoration: underline;
          padding: 5px 0;
          font-size: 0.75em;
        }
        .remove:hover {
          color: $link_hover;
        }
      }
    }
  }
  .login-existing-account {
    h2 {
      font-size: 1.1em;
      margin-bottom: 1em;
    }
    input[type="radio"] {
      height: 20px;
      margin: 0px 10px 0px 5px;
      vertical-align: middle;
      width: 20px;
    }
    span {
      font-size: 0.95em;
    }
    label {
      margin-top: 1em;

      em {
        font-size: 0.9em;
      }
    }
  }
  .address-view {
    h2 {
      font-size: 1em;
      color: $text_color;
      margin-bottom: 1em;
    }
    input[type="radio"] {
      height: 20px;
      margin: 0px 10px 0px 5px;
      vertical-align: middle;
      width: 20px;
    }
    span {
      font-size: 0.95em;
    }
    input[type="checkbox"] {
      height: 20px;
      margin: 0px 0.7em 0px 5px;
      vertical-align: middle;
      width: 20px;
    }

    label {
      align-items: center;
      cursor: pointer;
      display: flex;

      &:last-of-type {
        margin-top: 1em;
      }

      span.active {
        font-weight: 500;
        color: $text_color;
      }
    }

    .existing-account {
      font-size: 0.9em;
      margin: 1em 2.5em;

      p {
        line-height: 130%;
      }
    }

    .account-information {
      margin-top: 2em;
    }
  }
  .delivery-time {
    margin: 2em 0;

    p {
      font-size: 1.09em;
      margin: 2em 0;
    }
  }

  .loading-options {
    margin: 2em 0;

    & > p {
      margin-bottom: 18px;
    }

    label {
      display: block;
      font-size: 0.8em;
      margin-bottom: 15px;
      input[type="radio"] {
        margin-left: 0;
      }

      &:hover {
        cursor: pointer;
      }
    }

    input[type="checkbox"] {
      height: 20px;
      margin-right: 0.7em;
      margin-bottom: 0em;
      vertical-align: sub;
      width: 20px;
    }
  }

  .check-out-view {
    font-size: 0.9em;

    h4 {
      font-weight: 500;
      margin-bottom: 1em;
    }
    .product-view {
      font-size: 1em;
      margin-right: 1em;
      .header {
        margin-bottom: 1em;
      }
      .description {
        width: 75%;
      }
      .quantity {
        width: 5%;
        display: block;
        text-align: right;
      }
    }
    span.right {
      float: right;
    }
    .total {
      margin-right: 1em;
      margin-bottom: 1em;
    }
    .notes {
      width: 100%;
      padding: 1em;
      height: 150px;
      border-radius: 8px;
      resize: none;
    }
    p.link {
      text-align: center;
    }
  }
  button.action {
    margin: 1em auto;
  }
  p.delete-quote {
    text-align: center;
  }

  .empty-order {
    p {
      margin-bottom: 1em;

      strong {
        font-weight: 500;
      }
    }
  }

  footer {
    svg {
      margin-right: 0.5em;
      vertical-align: bottom;
    }
  }
}
</style>
